// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {TreeItem} from '@material-ui/lab';
import {Checkbox, FormControlLabel} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    checkbox: {
        marginLeft: theme.spacing(2),
    },
}));

const TreeNode = ({label, checked, children, disabled, nodeId, onChange, value}) => {
    const classes = useStyles();
    return (
        <TreeItem
            key={nodeId}
            label={
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            className={classes.checkbox}
                            color="primary"
                            disabled={disabled}
                            value={value}
                            onChange={onChange}
                            onClick={e => e.stopPropagation()}
                        />
                    }
                    label={label}
                />
            }
            nodeId={nodeId}
        >
            {typeof children === 'function' ? children() : children}
        </TreeItem>
    );
};

TreeNode.propTypes = {
    checked: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    disabled: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    nodeId: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.string.isRequired,
};

export default TreeNode;
